import { Plus, Trash2 } from 'lucide-react';
import './CreateTestCaseModal.css';

export default function StepsEditor({ steps, onChange }) {
  function addStep() {
    onChange([...steps, { description: '', expectedResult: '' }]);
  }

  function removeStep(i) {
    onChange(steps.filter((_, idx) => idx !== i));
  }

  function updateStep(i, field, value) {
    onChange(steps.map((s, idx) => (idx === i ? { ...s, [field]: value } : s)));
  }

  return (
    <div className="ctc-steps">
      {steps.length > 0 && (
        <div className="ctc-steps-header">
          <span className="ctc-steps-col-label ctc-steps-col-num">#</span>
          <span className="ctc-steps-col-label ctc-steps-col-desc">
            Description <span className="ctc-required">*</span>
          </span>
          <span className="ctc-steps-col-label ctc-steps-col-expected">Expected Result</span>
          <span className="ctc-steps-col-label ctc-steps-col-remove" />
        </div>
      )}
      {steps.map((step, i) => (
        <div key={i} className="ctc-step-row">
          <span className="ctc-step-num">{i + 1}</span>
          <textarea
            className="ctc-textarea ctc-step-desc"
            value={step.description}
            onChange={e => updateStep(i, 'description', e.target.value)}
            placeholder="Step description"
            rows={2}
          />
          <textarea
            className="ctc-textarea ctc-step-expected"
            value={step.expectedResult}
            onChange={e => updateStep(i, 'expectedResult', e.target.value)}
            placeholder="Expected result (optional)"
            rows={2}
          />
          <button
            type="button"
            className="ctc-step-remove"
            onClick={() => removeStep(i)}
            title="Remove step"
          >
            <Trash2 size={13} />
          </button>
        </div>
      ))}
      <button type="button" className="ctc-add-step-btn" onClick={addStep}>
        <Plus size={13} /> Add Step
      </button>
    </div>
  );
}
